export default __webpack_public_path__ + "static/B0305-61bc038a71b2c8c6b0d2788f5fea0264.png";